import { useState } from "react";

const specialtyNotes = [
  {
    id: "graduation",
    name: "Graduation",
    weight: "1 Gram Fine Gold 9999",
    images: {
      obverse: "/graduation-note.png",
    },
    description: "Celebrate academic achievement with this stunning Graduation Goldnote. The perfect gift to commemorate a milestone moment, featuring elegant design and the timeless value of pure gold.",
  },
  {
    id: "ontario-trillium",
    name: "Ontario Trillium",
    weight: "1 Gram Fine Gold 9999",
    images: {
      obverse: "/ontario-trillium.png",
    },
    description: "Celebrate Ontario's provincial heritage with the stunning Trillium Goldnote. Featuring the iconic white trillium flower alongside the provincial coat of arms and beautiful northern lights imagery.",
  },
  {
    id: "cybernote",
    name: "Cybernote",
    weight: "5 Grams Silver 999 + 10,000 Satoshis",
    images: {
      obverse: "/cybernote.png",
    },
    description: "The revolutionary Cybernote bridges physical precious metals with digital cryptocurrency. Featuring 5 grams of .999 fine silver combined with 10,000 Satoshis of Bitcoin, secured via QR authentication. A groundbreaking fusion of traditional and digital assets.",
  },
];

// Specialty Note Card Component
const SpecialtyNoteCard = ({ note }) => {
  return (
    <div className="group">
      <div className="relative bg-[#0A0A0A] border border-white/10 rounded overflow-hidden">
        {/* Image Container */}
        <div className="relative aspect-[4/3] p-6 flex items-center justify-center">
          <img 
            src={note.images.obverse} 
            alt={note.name}
            className="max-w-full max-h-full object-contain group-hover:scale-105 transition-transform duration-500"
          />
        </div>
      </div>
      
      {/* Info */}
      <div className="mt-5 text-center">
        <p className="text-[0.6rem] tracking-[0.2em] uppercase text-[#D4AF37]/60 mb-2">{note.weight}</p>
        <h3 className="text-xl text-white/90 mb-2" style={{ fontFamily: 'Cinzel, serif' }}>{note.name}</h3>
        <p className="text-[#D4AF37] text-xs tracking-[0.2em] uppercase font-medium mb-3">Coming Soon</p>
        <p className="text-xs text-white/70 font-light leading-relaxed max-w-sm mx-auto">{note.description}</p>
      </div>
    </div>
  );
};

export const SpecialtyNotes = () => {
  return (
    <div className="min-h-screen bg-[#050505]" data-testid="specialty-notes-page">
      {/* Hero Section */}
      <section className="relative py-20 md:py-28">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <p className="text-[0.625rem] tracking-[0.3em] uppercase text-[#D4AF37]/80 mb-6 animate-fade-in">
              Limited Editions
            </p>
            <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl leading-[0.9] mb-8 animate-fade-in-up">
              <span className="gold-gradient">Specialty</span>
              <br />
              <span className="text-white/90">Notes</span>
            </h1>
            <p className="text-lg md:text-xl text-white/70 font-light leading-relaxed max-w-2xl mx-auto animate-fade-in-up-delay-1">
              Exclusive designs for life's most meaningful moments. 
              Sign up to be notified when these limited edition notes become available.
            </p>
          </div>
        </div>
      </section>

      {/* Specialty Notes Grid */}
      <section className="pb-24" data-testid="specialty-notes-grid">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 max-w-6xl mx-auto">
            {specialtyNotes.map((note) => (
              <SpecialtyNoteCard key={note.id} note={note} />
            ))}
          </div>
        </div>
      </section>

      {/* Notify Me Section */}
      <section className="py-20 bg-[#0A0A0A]">
        <div className="container mx-auto px-6">
          <div className="max-w-xl mx-auto text-center">
            <p className="text-[0.625rem] tracking-[0.3em] uppercase text-[#D4AF37]/80 mb-4">
              Stay Updated
            </p>
            <h2 className="text-2xl md:text-3xl text-white/90 mb-4" style={{ fontFamily: 'Cinzel, serif' }}>
              Get Notified
            </h2>
            <p className="text-white/80 font-light mb-8">
              Be the first to know when our specialty notes become available.
            </p>
            
            <form className="flex flex-col sm:flex-row gap-3" onSubmit={(e) => { e.preventDefault(); }}>
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 px-5 py-3 bg-[#121212] border border-white/10 rounded text-white placeholder:text-white/30 focus:border-[#D4AF37]/50 focus:outline-none text-sm"
              />
              <button 
                type="submit"
                className="px-8 py-3 bg-[#D4AF37] text-black text-xs tracking-[0.15em] uppercase font-medium rounded hover:bg-[#EEDC9A] transition-colors"
              >
                Notify Me
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SpecialtyNotes;
